import { apiHeaders } from './helpers.js';


let _prefSaveTimer = null;
let _prefDirty = {};

/**
 * Save a preference to localStorage and queue a server sync (if authenticated).
 * For layer_* keys (legacy), they are grouped into a single 'layers' object on the server.
 * For mapLayer:slug keys (registry-based), they are grouped into a single 'mapLayers' object.
 */
export function savePref(key, value) {
    if (key.startsWith('mapLayer:')) {
        localStorage.setItem(key, value);
        const mapLayers = {};
        for (let i = 0; i < localStorage.length; i++) {
            const k = localStorage.key(i);
            if (k && k.startsWith('mapLayer:')) {
                const v = localStorage.getItem(k);
                if (v !== null) mapLayers[k.slice(9)] = v;
            }
        }
        _prefDirty['mapLayers'] = mapLayers;
    } else if (key.startsWith('layer_')) {
        localStorage.setItem(key, value);
        const layers = {};
        ['bw', 'amb', 'pol', 'lfl', 'heli'].forEach(k => {
            const v = localStorage.getItem('layer_' + k);
            if (v !== null) layers[k] = v;
        });
        _prefDirty['layers'] = layers;
    } else {
        localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
        _prefDirty[key] = value;
    }

    if (!window.__APP.isAuth) return;

    clearTimeout(_prefSaveTimer);
    _prefSaveTimer = setTimeout(_flushPrefs, 1500);
}

function _flushPrefs() {
    if (Object.keys(_prefDirty).length === 0) return;
    const payload = Object.assign({}, _prefDirty);
    _prefDirty = {};
    clearTimeout(_prefSaveTimer);
    _prefSaveTimer = null;
    if (!window.__APP?.isAuth) return;
    fetch('/api/v1/user/preferences', {
        method: 'POST',
        headers: apiHeaders(true),
        body: JSON.stringify(payload),
    }).catch(() => {});
}

// Flush unsaved prefs before page unload
window.addEventListener('beforeunload', () => {
    if (Object.keys(_prefDirty).length === 0) return;
    const csrf = document.querySelector('meta[name="csrf-token"]')?.content || '';
    const payload = Object.assign({_token: csrf}, _prefDirty);
    _prefDirty = {};
    if (!window.__APP?.isAuth) return;
    navigator.sendBeacon('/api/v1/user/preferences', new Blob([JSON.stringify(payload)], {type: 'application/json'}));
});

/**
 * Apply server preferences to localStorage on initial load.
 * Server prefs take priority (they represent the user's cross-device state).
 */
export function applyServerPrefs() {
    if (!window.__APP.isAuth) return;
    const prefs = window.__APP.preferences;
    if (!prefs || typeof prefs !== 'object' || Object.keys(prefs).length === 0) return;

    const simpleKeys = ['hideTest', 'pinIcons', 'pinGrip', 'tileMode', 'vrVisible',
        'gemVisible', 'mapBoundsFilter', 'activeFeedId', 'theme', 'legendCollapsed', 'sound',
        'ttsEnabled', 'ttsFull', 'ttsDisc', 'ttsPrio', 'viewMode', 'textMode', 'freshWindow'];
    simpleKeys.forEach(key => {
        if (prefs[key] !== undefined && prefs[key] !== null) {
            localStorage.setItem(key, String(prefs[key]));
        }
    });

    ['filters', 'mapView'].forEach(key => {
        if (prefs[key] !== undefined && prefs[key] !== null) {
            localStorage.setItem(key, typeof prefs[key] === 'string' ? prefs[key] : JSON.stringify(prefs[key]));
        }
    });

    if (prefs.layers && typeof prefs.layers === 'object') {
        Object.entries(prefs.layers).forEach(([k, v]) => {
            localStorage.setItem('layer_' + k, String(v));
        });
    }

    if (prefs.mapLayers && typeof prefs.mapLayers === 'object') {
        Object.entries(prefs.mapLayers).forEach(([slug, v]) => {
            localStorage.setItem('mapLayer:' + slug, String(v));
        });
    }
}
